import styled, { css } from "styled-components";

export const Container = styled.div`
  background: #fff;
  box-sizing: border-box;
  overflow-x: hidden;
  ${'' /* width: 100%; */}
  max-width: 100vw;
  margin-right: 30px;
  display: flex;
  flex-direction: row;
  ${'' /* background-color: gray; */}

  .checkbox_fixed {
    left: 0px;
    position: sticky;
    z-index: 15;
  }

  .custom-table {
    border-collapse: collapse;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    flex: 2;
    overflow-x: auto;

    .invisible {
      display: none;
    }

    & > thead {
      top: 0;
      height: 45px;
      position: sticky;
      z-index: ;
      & > tr {
        background-color: var(--blue-light);
        ${'' /* border-radius: 5px 5px 0px 0px; */}
        height: 45px;
      }
    }

    & > tbody {
      // z-index: 5;
    }

    & > tbody > tr {
      height: auto;
      min-height: 70px;
      &:last-child {
        border-radius: 0px 0px 5px 5px;
      }
    }
  }

  .custom-table th,
  .custom-table td {
    padding: 8px;
    border: 0;
    z-index: ${({ isImageVisorOpen }) => (isImageVisorOpen ? 1 : 10)};
    max-width: 270px;
  }

  .custom-table th {
    border-radius: 5px 0 0 5px;
    border: 0;
    color: var(--black);
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    text-wrap: nowrap;
    z-index: ${({ isImageVisorOpen }) => (isImageVisorOpen ? 1 : 10)};
  }

  .custom-table td {
    background: var(--white-contentoh);
    z-index: 1;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-table tr {
    background: var(--white-contentoh);
    border-bottom: 1px solid var(--gray-light);
    ${'' /* border-left: 1px solid var(--gray-light); */}
    border-right: 1px solid var(--gray-light);
    display: flex;
    align-items: center;
    justify-content: space-around;
    z-index: 5;
    ${({ withCheckbox }) => withCheckbox && `padding-left: 10px;`}
  }
`;

export const TH = styled.th`
  background: var(--blue-light);
  min-height: ${({ height }) => height ?? "auto"};
  min-width: ${({ width }) => width ?? "270px"};
  position: relative;
  text-align: ${({ fixed }) => (fixed ? 'left' : 'center')};
  left: ${({ fixedToLeft }) => (fixedToLeft >= 0 ? `${fixedToLeft}px` : "20px")};
  z-index: ${({ fixed }) => (fixed ? 15 : 1)};
  ${({ fixedToLeft, withCheckbox }) =>
    fixedToLeft >= 0 &&
    css`
      left: ${withCheckbox ? 20 + fixedToLeft : fixedToLeft}px;
    `}
`;

export const TD = styled.td`
  align-items: center;
  background: var(--white-contentoh);
  box-sizing: border-box;
  display: flex;
  height: 100%;
  min-width: ${({ width }) => width ?? "270px"};
  text-align: center;
  // justify-content: ${({ fixed }) => (fixed ? 'left' : 'center')};
  vertical-align: middle;
  position: ${({ fixed }) => (fixed ? 'sticky' : 'relative')};
  left: ${({ fixedToLeft }) => (fixedToLeft >= 0 ? `${fixedToLeft}px` : "20px")};
  z-index: ${({ fixed }) => (fixed ? 15 : 'unset!important')};
  text-wrap: nowrap;
  overflow: ${({ fixed }) => (fixed ? 'auto' : 'unset')};

  .content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .button-save {
    padding: 3px;
    width: 24px;
    height: 24px;
    .icon {
      font-size: 18px;
    }
  }

  .container-attribute{
    display: flex;
    gap: 5px;
    align-items: center;
  }

  ${({ fixedToLeft, withCheckbox }) =>
    fixedToLeft >= 0 &&
    css`
      left: ${withCheckbox ? 20 + fixedToLeft : fixedToLeft}px;
    `}
`;

export const TableContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  flex: 0 0 28%; /* Ancho fijo */
  width: 300px; /* Ajusta según tus necesidades */
  z-index: 10; 
  border-left: 1px solid var(--gray-light);
  border-right: 1px solid var(--gray-light);
  ${'' /* background-color: gray; */}
`;

export const TableRow = styled.div`
  display: flex;
  width: 100%;
`;

export const TableCell = styled.div`
  flex: ${({ width }) => (width ? '0 0 auto' : '1')};
  width: ${({ width }) => width || 'auto'};
  padding: 8px;
  border-bottom: 1px solid var(--gray-light);
  box-sizing: border-box;
  overflow-x: auto;
  height: 71px;
  text-wrap: nowrap;
`;

export const TableHeaderCell = styled(TableCell)`
  background-color: var(--blue-light);
  ${'' /* border-radius: 0px 0px 0px 0px; */}
  height: 45px;
`;

export const StyledTableWrapper = styled.div`
  flex: 1;
  overflow-x: auto;
  height: 100%;
  padding: 0 0 8px 0;
    &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--blue-light);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--purple-light-contentoh);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--purple);
  }
`;